/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module basic-styles/overline/overlineui
 */

import { Plugin } from 'ckeditor5/src/core';
import { ButtonView } from 'ckeditor5/src/ui';

import overlineIcon from '../../theme/icons/overline.svg';

const OVERLINE = 'overline';

/**
 * The overline UI feature. It introduces the Overline button.
 *
 * @extends module:core/plugin~Plugin
 */
export default class OverlineUI extends Plugin {
	/**
	 * @inheritDoc
	 */
	static get pluginName() {
		return 'OverlineUI';
	}

	/**
	 * @inheritDoc
	 */
	init() {
		const editor = this.editor;
		const t = editor.t;

		// Add bold button to feature components.
		editor.ui.componentFactory.add( OVERLINE, locale => {
			const command = editor.commands.get( OVERLINE );
			const view = new ButtonView( locale );

			view.set( {
				label: t( 'Overline' ),
				icon: overlineIcon,
				keystroke: 'CTRL+L',
				tooltip: true,
				isToggleable: true
			} );

			view.bind( 'isOn', 'isEnabled' ).to( command, 'value', 'isEnabled' );

			// Execute command.
			this.listenTo( view, 'execute', () => {
				editor.execute( OVERLINE );
				editor.editing.view.focus();
			} );

			return view;
		} );
	}
}
